export default "__VITE_ASSET__zrfr3B0u__"